module.exports = __webpack_public_path__ + "img/20190614162256621.fba0fc0d.png";